import { render, staticRenderFns } from "./BlockSteps.vue?vue&type=template&id=4c22510a"
import script from "./BlockSteps.vue?vue&type=script&lang=js"
export * from "./BlockSteps.vue?vue&type=script&lang=js"
import style0 from "./BlockSteps.vue?vue&type=style&index=0&id=4c22510a&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports